var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-page"},[_c('AgileWrap',{attrs:{"photos":_vm.gallery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }